// Configuración (solo el director): usuarios, tabla de precios, IA (modelo, llave —nunca se enseña— y tope), acceso y
// CRM de Carlos, y la bitácora del sistema (contrato v2).
import { useEffect, useRef } from 'react';
import { Enlace } from '../../ruteo.tsx';
import { usarUsuario } from '../../sesion.tsx';
import { Vacio } from '../../componentes/ui.tsx';
import { Usuarios } from './Usuarios.tsx';
import { Precios } from './Precios.tsx';
import { ConfigIA } from './ConfigIA.tsx';
import { Acceso } from './Acceso.tsx';
import { Bitacora } from './Bitacora.tsx';

const PESTANAS = [
  { id: 'usuarios', texto: 'Usuarios' },
  { id: 'precios', texto: 'Precios' },
  { id: 'ia', texto: 'IA' },
  { id: 'acceso', texto: 'Acceso y CRM' },
  { id: 'bitacora', texto: 'Bitácora' },
] as const;

export function Configuracion({ pestana }: { pestana: string }) {
  const { usuario } = usarUsuario();
  const barra = useRef<HTMLElement>(null);
  useEffect(() => {
    // En el celular las pestañas se desplazan: la abierta siempre queda a la vista.
    const activa = barra.current?.querySelector<HTMLElement>('.es-activo');
    if (activa && typeof activa.scrollIntoView === 'function') activa.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [pestana]);
  if (usuario.rol !== 'director')
    return (
      <div className="pagina">
        <Vacio titulo="Solo Diego entra aquí">La configuración (usuarios, precios, IA y bitácora) es del director.</Vacio>
      </div>
    );
  const actual = PESTANAS.find((p) => p.id === pestana)?.id ?? 'usuarios';
  return (
    <div className="pagina pagina--config">
      <header className="pagina__cabeza">
        <h1 className="pagina__titulo">Configuración</h1>
      </header>
      <nav className="pestanas pestanas--config" aria-label="Configuración" ref={barra}>
        {PESTANAS.map((p) => (
          <Enlace key={p.id} a={`/configuracion/${p.id}`} className={['pestanas__item', actual === p.id ? 'es-activo' : ''].join(' ')} aria-current={actual === p.id ? 'page' : undefined}>
            {p.texto}
          </Enlace>
        ))}
      </nav>
      {actual === 'usuarios' && <Usuarios />}
      {actual === 'precios' && <Precios />}
      {actual === 'ia' && <ConfigIA />}
      {actual === 'acceso' && <Acceso />}
      {actual === 'bitacora' && <Bitacora />}
    </div>
  );
}
